module.exports = __webpack_public_path__ + "f7184cebfda231c48b9eeb319ae92d41.svg";